import { RootState } from '@/store/main';

export const selectSpeakers = (state: RootState) => state.speakers.speakers;
export const selectIsLoadingSpeakers = (state: RootState) => state.speakers.loadingSpeakers;
